module.exports = __webpack_public_path__ + "static/random-user-generator-47a8e0c2941ecf5e2f8ba557a24aefd9.gif";